module.exports = __webpack_public_path__ + "media/slot-game/tea-eb661f2d.svg";